import { breakpoints } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

import { TitleCSS } from '../styled';

export const Title = styled.div`
  ${TitleCSS}
  margin-bottom: 1.5rem;
  padding-left: 0.9375rem;
`;

interface IContainerProps {
  withDivider?: boolean;
}

export const Container = styled.section<IContainerProps>`
  box-sizing: border-box;
  display: flex;
  @media (min-width: ${breakpoints.md}) {
    margin: 0;
    border-top: 0;
  }
`;

export const Wrapper = styled.div`
  height: inherit;
  width: 100%;
`;
